import { API_BASE_URL } from './channelService';
import { userService } from './userService';

export interface ShopifyStatus {
  success: boolean;
  isConnected: boolean;
  authenticated: boolean;
  channel_id?: string;
  shop_domain?: string;
  display_name?: string;
  connected_at?: string;
  message?: string;
}

async function getStatus(sessionStart?: string): Promise<ShopifyStatus> {
  const jwtToken = await userService.getAuthToken();
  const qs = new URLSearchParams();
  if (sessionStart) qs.set('session_start', sessionStart);
  const url = `${API_BASE_URL}/shopify-status${qs.toString() ? `?${qs.toString()}` : ''}`;
  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${jwtToken}`,
    },
  });
  if (!response.ok) {
    const text = await response.text();
    throw new Error(`Shopify status failed: ${response.status} - ${text}`);
  }
  return await response.json();
}

export const shopifyStatusService = {
  getStatus,
};


